module.exports = __webpack_public_path__ + "static/media/handle1.06487f20.png";